import api from '@/api';

const resource = 'ei/configuracaoanoletivo';

export default {
  getMinimo(data){
    return api.get(`${resource}/listarminimo`,{
      params: data,
    })
  },
  postMinimo(data) {
    return api.post(`${resource}/minimo`, data);
  },
  putMinimo(data) {
    return api.put(`${resource}/minimo/${data.identificadorconfiguracaoanoletivo}`, data);
  },
  getFechamento(data){
    return api.get(`${resource}/listarfechamento`,{
      params: data,
    })
  },
  postFechamento(data) {
    return api.post(`${resource}/fechamento`, data);
  }
};